// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = require('./$.wks')('unscopables')
  , ArrayProto  = Array.prototype;
if(ArrayProto[UNSCOPABLES] == undefined)require('./$.hide')(ArrayProto, UNSCOPABLES, {});
module.exports = function(key){
  ArrayProto[UNSCOPABLES][key] = true;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.add-to-unscopables.js
 ** module id = 319
 ** module chunks = 0
 **/